/* eslint-disable max-len */
export const cartLine = `
id
quantity
attributes {
  key
  value
}
cost {
  totalAmount {
    amount
    currencyCode
  }
  compareAtAmountPerQuantity {
    amount
    currencyCode
  }
}
merchandise {
  ... on ProductVariant {
    id
    quantityAvailable
    selectedOptions {
      name
      value
    }
    compareAtPrice {
      amount
    }
    product {
      ... on Product {
        title
        handle
        id
        featuredImage {
          alt: altText
          height
          id
          src: url(transform: { preferredContentType: WEBP })
          width
        }
        vendor
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  subtotalAmount {
    amount
    currencyCode
  }
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const variantMetaFields = `
backInStockDate: metafield(namespace: "variant", key: "back_in_stock_date"){
  value
}
`;

export const variant = `
availableForSale
quantityAvailable
currentlyNotInStock
sku
title
id
price {
  amount
  currencyCode
}
compareAtPrice {
  amount
  currencyCode
}
selectedOptions {
  name
  value
}
${variantMetaFields}
`;

export const metaFields = `
promotionalCopy: metafield(namespace: "product", key: "promotional_copy") {
  value
}
colorFamily: metafield(namespace: "product", key: "color_family") {
  value
}
swatchProducts: metafield(namespace: "product", key: "app_color_variants") {
  value
}
availableColors: metafield(namespace: "product", key: "available_colors") {
  value
}
swatchURL: metafield(namespace: "product", key: "swatch") {
  value
  reference {
    ...on MediaImage {
      image {
        url
      }
    }
  }
}
appColorVariants: metafield(namespace: "product", key: "app_color_variants") {
  value
}
hideAddToCart: metafield(namespace: "product", key: "hide_add_to_cart") {
  value
}
sizeTable: metafield(namespace: "product", key: "size_chart") {
  value
}
sizeTableTitle:  metafield(namespace: "product", key: "size_table_title") {
  value
}
sizeBtnTitle: metafield(namespace: "product", key: "size_btn_title") {
  value
}
shippingReturns: metafield(namespace: "product", key: "shipping_returns") {
  value
}
productDetailsIcons: metafield(namespace: "product", key: "icons_with_text") {
  value
}
breadcrumbCat: metafield(namespace: "breadcrumb", key: "category") {
  value
}
breadcrumbHandle: metafield(namespace: "breadcrumb", key: "collection_handle") {
  value
}
sizeGuide: metafield(namespace: "product", key: "size_chart") {
  value
}
fitText: metafield(namespace: "fit", key: "text") {
  value
}
hideReviews: metafield(namespace: "section", key: "hide_reviews_section") {
  value
}
modelSizing: metafield(namespace: "details", key: "model_sizing") {
  value
}
hideGift: metafield(namespace: "customization", key: "hide_gift_wrap_options") {
  value
}
finalSale: metafield(namespace: "disposition", key: "final_sale") {
  value
}
`;

export const product = `
availableForSale
handle
id
title
handle
descriptionHtml
productType
vendor
metafield(key: "complete_the_look_entries", namespace: "product") {
  id
  type
  value
  key
  namespace
  references(first: 10) {
    nodes {
      ... on Metaobject {
        id
        handle
        fields {
          key
          value
          reference {
            ... on MediaImage {
              id
              image {
                url
              }
            }
          }
          references(first: 10) {
            nodes {
              ... on Product {
                id
                handle
                featuredImage {
                  originalSrc
                  url
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
collections(first: 10) {
  edges {
    node {
      title
      handle
    }
  }
}
media(first: 10) {
  edges {
    node {
      mediaContentType
      ... on ExternalVideo {
        alt
        embedUrl
        id
        host
        previewImage {
          altText
          height
          width
          url
        }
      }
      ... on MediaImage {
        id
        alt
        image{
          altText
          height
          width
          url
        }
      }
    }
  }
}
images(first: 50) {
  edges {
    node {
      alt: altText
      height
      id
      src: url(transform: { preferredContentType: WEBP })
      width
    }
  }
}
tags
options {
  id
  name
  values
}
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
variants(first: 100) {
  edges {
    node {
      ${variant}
    }
  }
}
${metaFields}
metafields(identifiers: [
  { namespace: "customize", key: "image" },
  { namespace: "customize", key: "placement" },
  { namespace: "customize", key: "monogram_type" },
  { namespace: "customize", key: "motif" },
  { namespace: "customize", key: "names" },
  { namespace: "customize", key: "monogram" }
]) {
  key
  value
  namespace
  reference {
    ...on MediaImage {
      image {
        url
      }
    }
  }
}
`;

export const productWithVariants = `
${product}
variants(first: 100) {
  edges {
    node {
      ${variant}
    }
  }
}
`;

export const cartSupplementaryData = `
  compareAtPriceRange {
    minVariantPrice {
      amount
      currencyCode
    }
  }
  hideGift: metafield(namespace: "customization", key: "hide_gift_wrap_options") {
    value
  }
`;
